import { datadogLogs } from '@datadog/browser-logs';
import debug from 'debug';
/*
  Usage:-
    logs will show in development only, in production logs will be disabled
    to turn on in production set localStorage.debug = 'MG*';

  import { Logger } from '@montugroup/utilities';
  const logger = new Logger('MyComponent');
  ...
  ...
  logger.info(`hello world ${someValue}`);

*/
const NAMESPACE = 'MG';
const ENABLE_DDOG = process.env.NODE_ENV === 'production';
if (!ENABLE_DDOG) {
    debug.enable(`${NAMESPACE}*`);
}
export class Logger {
    _debug;
    _info;
    _warn;
    _error;
    _critical;
    prefix;
    enableDDogBrowserLogs;
    static getUserIdFunc;
    constructor(prefix) {
        if (prefix) {
            this._debug = debug(`${NAMESPACE}:${prefix}`);
            this._info = debug(`${NAMESPACE}:INFO:${prefix}`);
            this._warn = debug(`${NAMESPACE}:WARN:${prefix}`);
            this._error = debug(`${NAMESPACE}:ERROR:${prefix}`);
            this._critical = debug(`${NAMESPACE}:CRITICAL:${prefix}`);
        }
        else {
            this._debug = debug(`${NAMESPACE}`);
            this._info = debug(`${NAMESPACE}:INFO`);
            this._warn = debug(`${NAMESPACE}:WARN`);
            this._error = debug(`${NAMESPACE}:ERROR`);
            this._critical = debug(`${NAMESPACE}:CRITICAL`);
        }
        this.enableDDogBrowserLogs = ENABLE_DDOG;
        this.prefix = prefix;
        this._debug.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.debug.apply(console, arguments);
        };
        this._info.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.info.apply(console, arguments);
        };
        this._warn.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.warn.apply(console, arguments);
        };
        this._error.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.error.apply(console, arguments);
        };
        this._critical.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.error.apply(console, arguments);
        };
    }
    debug(...args) {
        this.wrapLog(this._debug, 'debug', ...args);
    }
    info(...args) {
        this.wrapLog(this._info, 'info', ...args);
    }
    warn(...args) {
        this.wrapLog(this._warn, 'warn', ...args);
    }
    error(...args) {
        this.wrapLog(this._error, 'error', ...args);
    }
    critical(...args) {
        this.wrapLog(this._critical, 'error', ...args);
    }
    static getUserId() {
        if (Logger.getUserIdFunc) {
            return Logger.getUserIdFunc();
        }
        return undefined;
    }
    sendToDatadog(logLevel, ...args) {
        try {
            const first = args?.[0];
            const firstMsg = typeof first === 'string' || first instanceof String ? first : JSON.stringify(first);
            const msg = [NAMESPACE];
            if (this.prefix) {
                msg.push(this.prefix);
            }
            msg.push(firstMsg);
            const messageContext = {
                args,
                user_id: Logger.getUserId() || 'logged_out',
            };
            // find the first error in the args, and send this to ddog as an 'error'
            const err = args.find((x) => x instanceof Error);
            datadogLogs.logger.log(msg.join(':'), messageContext, logLevel, err);
        }
        catch (err) {
            console.error('failed to send to datadog: ', err);
        }
    }
    wrapLog = (logFunc, logLevel, ...args) => {
        logFunc(...args);
        if (this.enableDDogBrowserLogs && logLevel !== 'debug') {
            this.sendToDatadog(logLevel, ...args);
        }
    };
}
//# sourceMappingURL=data:application/json;base64,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